import type { ReactNode } from 'react'

import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { useTranslate } from '@/src/lang/useTranslate'

import type { TIntention } from '../../../models/Intention.types'
import { usePrettifyPrayers } from '../../hooks/usePrettifyPrayers'

type TIntentionPrayersProps = Pick<TIntention, 'prayers' | 'prayersCount'>

export const IntentionSinglePrayers = ({ prayers, prayersCount }: TIntentionPrayersProps): ReactNode => {
  const { t } = useTranslate()
  const prettyPrayers = usePrettifyPrayers(prayers)

  return (
    <Typography contrast="low" className="text-center" testID={TEST_ID.MISCELLANEOUS.INTENTION_WHO_PRAYED}>
      {t('intention.prayed.by', {
        count: prayersCount,
        name: prettyPrayers.first,
        otherNames: prettyPrayers.others,
        remainingCount: prayersCount - (prayers?.length || 0),
      })}
    </Typography>
  )
}
